import type { Biome, TreeSpecies } from '@thicket/core';

/**
 * What each tree is called in each place. The game's four species are by difficulty (birch,
 * maple, oak, pine); every biome grows its own native version of each, as drawn in the Lab.
 */
const NATIVE: Record<Biome, [string, string, string, string]> = {
  meadow: ['birch', 'maple', 'oak', 'spruce'],
  pineRidge: ['aspen', 'rowan', 'chestnut', 'Fraser fir'],
  wetland: ['black willow', 'swamp maple', 'tupelo', 'bald cypress'],
  jungleRuins: ['cecropia', 'flame tree', 'strangler fig', 'kapok'],
  canyon: ['palo verde', 'desert willow', 'mesquite', 'saguaro'],
  woodlandLake: ['weeping willow', 'dogwood', 'beech', 'white pine'],
  coast: ['sea grape', 'coconut palm', 'live oak', 'Monterey cypress'],
  mountainSummit: ['dwarf birch', 'larch', 'krummholz fir', 'bristlecone pine'],
  sacredGrove: ['ghost birch', 'spirit maple', 'moonwood oak', 'ancient yew'],
};
const SPECIES: TreeSpecies[] = ['birch', 'maple', 'oak', 'pine'];

/** The native name of a tree species in a biome ("spruce" for the meadow's pine, "saguaro" in the canyon). */
export function treeName(species: string, biome: Biome | null | undefined): string {
  const i = SPECIES.indexOf(species as TreeSpecies);
  if (i < 0) return species;
  return NATIVE[biome ?? 'meadow'][i] ?? species;
}

/** How a streak reads in a list: never a failure. */
export const streakText = (streak: number) => (streak > 0 ? `${streak}-day streak` : 'no streak yet');
